import { FC, useEffect, useState } from "react"
import {
  ChallengesService,
  Challenge
} from "../sdk"
import ChallengeCard from "../components/ChallengeCard"
import PageLoader from "../components/PageLoader"
import useError from "../hooks/useError"
import Button from "../components/Button"
import Modal from "../components/Modal"
import AddChallengeForm from "../components/AddChallengeForm"
import { toast } from "react-toastify"

const Challenges: FC = () => {
  const [challenges, setChallenges] = useState<Challenge[] | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [addChallengeModalOpen, setAddChallengeModalOpen] = useState<boolean>(false)

  const { handleError } = useError()

  const getChallenges = async(): Promise<void> => {
    try {
      const { data } = await ChallengesService.listChallenges({
        paginator: { offset: 0, limit: 100 }
      })
      setChallenges(data)
    } catch (err) {
      handleError(err)
    }
  }

  useEffect(() => {
    void (async(): Promise<void> => {
      await getChallenges()
      setLoading(false)
    })()
  }, [])

  return (
    <>
      {
        loading ?
          <PageLoader className="h-screen w-screen top-0 left-0 fixed"/>
          :
          <>
            <div className="flex mb-8">
              <h1 className="text-3xl font-semibold">Challenges</h1>
              <Button
                onClick={(): void => {
                  setAddChallengeModalOpen(true)
                }}
                className="ml-4"
              >
                Aggiungi
              </Button>
            </div>

            <div className="grid grid-cols-3 gap-6">
              {challenges && challenges.length !== 0 ?
                challenges.map((challenge) => {
                  return (
                    <ChallengeCard
                      challenge={challenge}
                      key={challenge.id}
                    />
                  )
                })
                :
                <p className="text-red-600 font-semibold">Nessuna challenge presente</p>
              }
            </div>
          </>
      }
      {addChallengeModalOpen &&
        <Modal
          className="challenge-modal"
          close={(): void => setAddChallengeModalOpen(false)}
          title="Crea Challenge"
        >
          <AddChallengeForm
            onSuccess={async(): Promise<void> => {
              await getChallenges()
              setAddChallengeModalOpen(false)
              toast.success("Challenge aggiunga correttamente!")
            }}
          />
        </Modal>
      }
    </>
  )
}

export default Challenges